import jquery from 'jquery';
import 'bootstrap';

import '@fancyapps/fancybox';


import './core/plugins/jquery.menu';
import './core/functions';
import './elements/search';
import './elements/newsletter';
import './elements/dropdown-menu';
import './elements/masonry-grid';

window.jQuery = jquery;
window.$ = jquery;
window.jquery = jquery;

var objLoader = $('.overlay-loader');

$(window).on('load', function (e) {
    objLoader = $('.overlay-loader');

    if (objLoader.length) {
        objLoader.removeClass('d-flex');
        objLoader.addClass('d-none');
        objLoader.find('.suggestion-loader').removeClass('active');
    }
});


$(window).on('beforeunload', function () {
    setTimeout(function () {
        objLoader.removeClass('d-none');
        objLoader.addClass('d-flex');
        objLoader.find('.suggestion-loader').addClass('active');
    }, 2000);
});


// Bootstrap tooltips
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

// Add hover for bootstrap dropdown
$(document).ready(function () {
    if ($(window).width() > 768) {

        $('.navbar .dropdown').hover(function () {
            // add classes for styling
            $(this).toggleClass('show');
            // Get the submenu
            var dropdownMenu = $(this).children('.dropdown-menu');
            dropdownMenu.toggleClass('show');

            if (dropdownMenu.length > 0) {
                $(this).parent().toggleClass('show-dropdown');
            }
        });

        $('.submenu .close').on('click', function () {
            $('ul.nav').removeClass('show-dropdown');
            $('.dropdown').removeClass('show');
            $('.dropdown-menu').removeClass('show');
        });
    }
});